import React, {useCallback} from 'react';

import {TREE_NAMES, TreeSkeleton} from 'src/components/features-section';
import {Skeleton} from 'src/components/skeleton';

import CheckBoxTree from '@pb/kit-component-checkbox-tree';
import Group from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';

import type {ChangeTreeType} from '@pb/kit-component-checkbox-tree';
import type {TreeStructure} from '@pb/kit-component-tree-v2';


type Props = {
    loading: boolean,
    platformFeatureModulesTree: TreeStructure | null,
    platformFeatureModules: Array<string>,
    onChange: (platformFeatureModules: Array<string>) => void,
    layoutLevel?: number,
};

export const PlatformFeatureModulesSection: React.FC<Props> = props => {
    const {loading, platformFeatureModulesTree, platformFeatureModules, onChange, layoutLevel} = props;

    const onTreeChange = useCallback((changeTreeType: ChangeTreeType) => {
        onChange(changeTreeType.checkedIdsList);
    }, [onChange]);

    return (
        <Skeleton view={<TreeSkeleton rows={24}/>} shown={loading}>
            <Group direction="v" gap="m">
                <Label>Platform Features</Label>
                {platformFeatureModulesTree ? (
                    <CheckBoxTree
                        data={platformFeatureModulesTree}
                        onChange={onTreeChange}
                        name={TREE_NAMES.PLATFORM_FEATURES}
                        checkedIdsList={platformFeatureModules}
                        layoutLevel={layoutLevel}
                    />
                ) : null}
            </Group>
        </Skeleton>
    );
};
